export namespace UiList {
    export enum Role {
        LIST       = 'list',
        MENU       = 'menu',
        NAVIGATION = 'navigation'
    }

    export enum Type {
       DEFAULT = 'default',
       NAV     = 'nav'
    }

    export enum ItemType {
        HEADER    = 'header',
        FOOTER    = 'footer',
        SEPARATOR = 'separator'
    }
}